module.exports = __webpack_public_path__ + "img/hbl3.db5decaf.png";